/* eslint-disable import/prefer-default-export */
import getQuery from '../../utilities/query';
import { loans } from '../../api';
import { handleError } from '../../utilities/errorHandling';

const queryClient = getQuery();

export const LOANS_REQUEST = 'loans.request';
export const LOANS_PAY_COLLATERAL = 'loans.payCollateralCrypto';

export const LOAN_PAY_INTEREST = 'loans.pay_interest';
export const LOAN_REPAY = 'loan.repay';

queryClient.setMutationDefaults(LOANS_REQUEST, {
  mutationFn: loans.request,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(LOAN_REPAY, {
  mutationFn: loans.repayLoanFiat,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(LOANS_PAY_COLLATERAL, {
  mutationFn: loans.payCollateralCrypto,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(LOAN_PAY_INTEREST, {
  mutationFn: loans.payInterestOverdue,
  onError: (error) => {
    handleError(error);
  },
});
